export default {
    emits: [
        'success',
        'closed'
    ],
    data () {
        return {
            tableData: [],
            total: 0,
            selection: [],
            visible: false,
            isSaveing: false,
            queryInfo: {
                page: 1,
                size: 10,
                keywords: ""
            },
            isLoading: false
        };
    },
    mounted () {
        this.getDataList();
    },
    methods: {
        //显示
        open () {
            this.visible = true;
            return this;
        },
        //! 分页功能
        paginationChange (page) {
            this.queryInfo.pageNo = page;
            this.getDataList();
        },
        //! 页码切换
        pageSizeChange (size) {
            this.queryInfo.pageSize = size;
            this.getDataList();
        },
        selectionChange (selection) {
            this.selection = selection;
        },
        submit () {
            this.isSaveing = true;
            this.$emit('success', this.selection);
            this.visible = false;
            this.isSaveing = false;
        },
        async getDataList () {
            this.isLoading = true;
            let res = await this.$API.goods.classify.list.get(this.queryInfo);
            this.isLoading = false;
            if (res?.code === 1) {
                this.tableData = res?.data || [];
                this.total = res?.data?.total || 0;
            }
        }
    }
};
